import { requestOptions } from '../helpers/request-options'
import { handleResponse } from '../helpers/handle-response'

export const addressesService = {
  getData,
  getDataById,
  deleteDataById,
  update,
  add,
  addOrgToAddress,
  updateOrgToAddress
}

function getData ({ q, limit, ordering, offset, expand = 'state,created_by,modified_by,organizations_addresses.organization' }) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/addresses/?${q}&limit=${limit}&ordering=${ordering}&offset=${offset}&expand=${expand}&organizations_addresses__property_status=active`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(addresses => {
      return addresses
    })
}

function getDataById (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/addresses/${id}/?expand=created_by,modified_by,state,organizations_addresses.organization`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(addresses => {
      return addresses
    })
}

function deleteDataById (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/addresses/${id}/`
  return fetch(url, requestOptions.delete())
    .then(handleResponse)
    .then(addresses => {
      return addresses
    })
}

function add (payload) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/addresses/`
  return fetch(url, requestOptions.post(payload))
    .then(handleResponse)
    .then(addresses => {
      return addresses
    })
}

function update (payload, id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/addresses/${id}/`
  return fetch(url, requestOptions.put(payload))
    .then(handleResponse)
    .then(addresses => {
      return addresses
    })
}

function addOrgToAddress (payload) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/organization-addresses/`
  return fetch(url, requestOptions.post(payload))
    .then(handleResponse)
    .then(addresses => {
      return addresses
    })
}

function updateOrgToAddress (payload, id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/organization-addresses/${id}/`
  return fetch(url, requestOptions.put(payload))
    .then(handleResponse)
    .then(addresses => {
      return addresses
    })
}



// WEBPACK FOOTER //
// ./src/services/addresses.service.js